import { render } from "./OverviewWidget.vue?vue&type=template&id=9b248b4e&scoped=true"
import script from "./OverviewWidget.vue?vue&type=script&lang=js"
export * from "./OverviewWidget.vue?vue&type=script&lang=js"

import "./OverviewWidget.vue?vue&type=style&index=0&id=9b248b4e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b248b4e"]])

export default __exports__